/**
 * Refuse le zoom de page. `user-scalable=no` suffit à Android et à
 * l'application installée, mais Safari en onglet l'ignore depuis iOS 10 : les
 * évènements `gesture*` y sont la seule prise restante sur le pincement.
 *
 * Rien d'autre n'est neutralisé, et surtout pas le `touchmove` à deux doigts :
 * le recadrage de photo lit son pincement en `PointerEvent`, et un
 * `preventDefault` sur `touchmove` annulerait ses pointeurs en cours de geste.
 * Les `gesture*` d'iOS vivent à côté de ce flux et ne l'interrompent pas.
 */
export const lockZoom = () => {
  const refuse = (event: Event) => event.preventDefault();
  for (const type of ["gesturestart", "gesturechange", "gestureend"]) {
    document.addEventListener(type, refuse, { passive: false });
  }
};
